import * as React from 'react';
import { useContext } from 'react';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { trackCallButtonClick } from '../CallButton/tracking';
import { PromoOfferDetailsControls } from '../PromoOfferDetailsControls';
import { trackBlockClick } from '../PromoOffersSelection/tracking';

interface IPromoModalProps {
  onPromoModalClose(): void;
}

export const PromoModal = ({ onPromoModalClose }: IPromoModalProps) => {
  const { promoInfo, offerUrl, gaLabel, offerId } = useContext(PromoOfferCardContext);

  const onCallClick = React.useCallback(
    () =>
      trackCallButtonClick({
        customUrl: gaLabel,
        id: offerId,
        action: 'Open_detail_promo',
        extra: { promoId: promoInfo.uniquePromoId, is_price_with_discount: promoInfo.promoType === 'discount' },
      }),
    [gaLabel, offerId, promoInfo],
  );

  const onOfferLinkClick = React.useCallback(
    () =>
      trackBlockClick({
        offersIds: [offerId],
        clickType: 'to_offers',
      }),
    [offerId],
  );

  return (
    <PromoDetailsModal
      onClose={onPromoModalClose}
      promoName={promoInfo.title}
      providerName={promoInfo.providerName}
      logo={promoInfo.providerLogo}
      features={promoInfo.promoProps}
      description={promoInfo.promoDescription}
      linkButton={
        <PromoOfferDetailsControls
          offerUrl={offerUrl}
          actionText={promoInfo.actionText}
          onCallButtonClick={onCallClick}
          onOfferLinkClick={onOfferLinkClick}
        />
      }
    />
  );
};
